import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface PlayIconProps {
  size?: number;
  color?: string;
}

const PlayIcon: React.FC<PlayIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-play">
    <path d="M16 10l24 15-24 15z"></path>
  </SvgIcon>
);

export default PlayIcon;
